import { render, staticRenderFns } from "./app.vue?vue&type=template&id=ba6a5ab4&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=ba6a5ab4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6a5ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/myapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba6a5ab4')) {
      api.createRecord('ba6a5ab4', component.options)
    } else {
      api.reload('ba6a5ab4', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=ba6a5ab4&scoped=true", function () {
      api.rerender('ba6a5ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/app.vue"
export default component.exports